export const STATUS_SUPERVISION_TYPES = Object.freeze({
	ACCOMPLISHED: 'ACCOMPLISHED',
	NOT_ACCOMPLISHED: 'NOT_ACCOMPLISHED',
	PENDING_TO_EXECUTE: 'PENDING_TO_EXECUTE',
	PENDING_TO_VALIDATE: 'PENDING_TO_VALIDATE',
	SUSPENDED: 'SUSPENDED',
});
